import classes from "./HomeCarusel.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import { useSelector } from "react-redux";

import { useIsMobile } from "../../utils/utils";

interface RootState {
  links: {
    topImage: string;
    topImageMobile: string;
    topImage1: string;
    topImage2: string;
    topImage3: string;
    topImage1Mobile: string;
    topImage2Mobile: string;
    topImage3Mobile: string;
  };
}

const Carusel: React.FC = () => {
  const isMobile = useIsMobile();
  const topImage1 = useSelector((state: RootState) =>
    isMobile ? state.links.topImage1Mobile : state.links.topImage1
  );
  const topImage2 = useSelector((state: RootState) =>
    isMobile ? state.links.topImage2Mobile : state.links.topImage2
  );
  const topImage3 = useSelector((state: RootState) =>
    isMobile ? state.links.topImage3Mobile : state.links.topImage3
  );
  const pageData = (
    <div className={classes.caruselContainer}>
      <Swiper
        slidesPerView={1}
        spaceBetween={0}
        pagination={false}
        navigation={false}
        modules={[Navigation, Pagination, EffectFade, Autoplay]}
        effect="fade"
        autoplay={{
          delay: 3200,
          disableOnInteraction: false,
        }}
      >
        <SwiperSlide className={classes.SwiperSlide}>
          <img src={topImage1} alt="topImage1" />
        </SwiperSlide>
        <SwiperSlide className={classes.SwiperSlide}>
          <img src={topImage2} alt="topImage2" />
        </SwiperSlide>
        <SwiperSlide className={classes.SwiperSlide}>
          <img src={topImage3} alt="topImage3" />
        </SwiperSlide>
      </Swiper>
    </div>
  );

  return pageData;
};

export default Carusel;
